import React, { useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';

import BRAND_PRIORITY from './BrandPriority@default.json';
import BRAND_PRIORITY_EXPERIMENT from './BrandPriorityExperiment@default.json';
import TrendingBrandsCarousel from './TrendingBrandsCarousel';
import TrendingBrandsToolTip from './TrendingBrandsToolTip';
import Store, { Context } from './store/store';
import TRANSLATIONS from './translations@default.json';

export const TrendingBrands = ({ availableBrands }) => {
	const [contextState] = useContext(Context);

	const { lazyStates } = contextState;

	const values = Object.values(lazyStates);

	const isReady = values.length > 0 && values.every((key) => key);

	return (
		<div
			className="flex w-full bg-white md:border md:border-solid border-gray-30 md:rounded my-4"
			data-testid="trending-brands">
			<div className="p-4 py-2 w-full">
				<div className="flex items-center justify-between w-full">
					<div className="text-title-sm text-tertiary">
						{isReady ? TRANSLATIONS.title : <Skeleton width={200} />}
					</div>
					{isReady && <TrendingBrandsToolTip />}
				</div>
				<TrendingBrandsCarousel
					availableBrands={availableBrands}
					isReady={isReady}
				/>
			</div>
		</div>
	);
};

export default () => {
	const {
		facets = [],
		adobeTagging: {
			CategorisationTagViewModel: { MainCategory, SubCategory } = {},
		} = {},
	} = useSelector((state) => state);

	const { ListerExposeBrandFacetEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const categories = [
		'Televisions',
		'Vacuums And Floor Cleaners',
		'Laptops',
		'Kettles And Toasters',
	];

	const isInExperiment =
		ListerExposeBrandFacetEnabled && categories.includes(SubCategory);

	let brands = isInExperiment
		? BRAND_PRIORITY_EXPERIMENT[SubCategory]
		: BRAND_PRIORITY[MainCategory];

	if (!brands) {
		return null;
	}

	brands = brands.map((brand) => brand.toLowerCase());

	const availableBrands = facets
		.find(({ Id }) => Id === 'brandname')
		?.FacetValues.filter(({ Name }) => brands.includes(Name.toLowerCase()))
		.sort(
			(a, b) =>
				brands.indexOf(a.Name.toLowerCase()) -
				brands.indexOf(b.Name.toLowerCase())
		)
		.slice(0, 6);

	if (!Array.isArray(availableBrands) || availableBrands?.length < 3) {
		return null;
	}

	const keys = availableBrands.map(({ Name }) => Name);

	const lazyStates = keys.reduce(
		(acc, key) => ({
			...acc,
			[key]: false,
		}),
		{}
	);

	return (
		<Store state={{ lazyStates }}>
			<TrendingBrands {...{ availableBrands }} />
		</Store>
	);
};
